import React from 'react';
import { useSelector } from 'react-redux';
import DynamicModal from '../dynamicComponents/DynamicModal';
import { createSelector } from '@reduxjs/toolkit';

const selectModalLoaderData = createSelector(
	[
		(state) => state.componentConfig.modals,
		(state) => state.sceneLoad.renderScene || false,
		(state) => state.sceneLoad.renderUI || false,
	],
	(modals, renderScene, renderUI) => {
		return {
			modals,
			renderScene,
			renderUI,
		};
	},
);

const ModalLoader = () => {
	console.log('%c ModalLoader rerendered', 'color:yellow');
	const { modals, renderScene, renderUI } = useSelector(
		selectModalLoaderData,
	);

	return (
		renderScene &&
		renderUI &&
		modals.map((modalConfig, ix) => (
			<DynamicModal key={ix} config={modalConfig} />
		))
	);
};

export default ModalLoader;
